import "./styles.scss";

export interface IHeaderProps {
  onClose: () => void;
}

const Header = ({ onClose }: IHeaderProps) => (
  <div className="contract-details-header">
    <h3 className="contract-details-header__title">
      <span className="rioglyph rioglyph-document contract-details-header__icon"></span>
      Detalhes do contrato
    </h3>
    <div
      className="close-sidebar cursor-pointer"
      onClick={onClose}
      aria-label="Fechar"
    >
      <span className="rioglyph rioglyph-remove"></span>
    </div>
  </div>
);

export default Header;
